// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iconStyle{
    fill : #CCCFD6 !important
}
.iconStyle1{
    fill : #B3B7C1 !important
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) .iconStyle1{
    fill: #FFFFFF !important;
  }
.ant-menu > .ant-menu-item .iconStyle:hover ,
.ant-menu > .ant-menu-submenu .iconStyle:hover,
.ant-menu > .ant-menu-item-active .iconStyle,
.ant-menu> .ant-menu-submenu-active .iconStyle,
.ant-menu > .ant-menu-item-open .iconStyle,
.ant-menu> .ant-menu-submenu-open .iconStyle,
.ant-menu > .ant-menu-item-selected .iconStyle,
.ant-menu > .ant-menu-submenu-selected .iconStyle {
 fill: #3249D7 !important;
}`, "",{"version":3,"sources":["webpack://./src/modules/Page/Components/Partials/style.css"],"names":[],"mappings":"AAAA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI,wBAAwB;EAC1B;AACF;;;;;;;;CAQC,wBAAwB;AACzB","sourcesContent":[".iconStyle{\n    fill : #CCCFD6 !important\n}\n.iconStyle1{\n    fill : #B3B7C1 !important\n}\n.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) .iconStyle1{\n    fill: #FFFFFF !important;\n  }\n.ant-menu > .ant-menu-item .iconStyle:hover ,\n.ant-menu > .ant-menu-submenu .iconStyle:hover,\n.ant-menu > .ant-menu-item-active .iconStyle,\n.ant-menu> .ant-menu-submenu-active .iconStyle,\n.ant-menu > .ant-menu-item-open .iconStyle,\n.ant-menu> .ant-menu-submenu-open .iconStyle,\n.ant-menu > .ant-menu-item-selected .iconStyle,\n.ant-menu > .ant-menu-submenu-selected .iconStyle {\n fill: #3249D7 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
